import cn from "classnames"
import Image from "components/Image"
import richText from "utilities/richText"

export default function FloatingSection({ blok }) {
  return (
    <section className="px-8 py-6 first:pt-12 last:pb-12">
      <div
        className={cn("image-content-container mx-auto flex max-w-screen-xl flex-col rounded-10 bg-white lg:gap-8", {
          "lg:flex-row": blok.orientation === "image_first",
          "lg:flex-row-reverse": blok.orientation === "content_first",
        })}
      >
        <div className="image-decor relative z-10 min-h-full lg:basis-1/2 xl:basis-1/3">
          <Image
            src={blok.image.filename}
            alt={blok.image.alt}
            placeholder={blok.image?.blurDataURL ? "blur" : "empty"}
            blurDataURL={blok.image?.blurDataURL}
            width={610}
            height={300}
            className={cn("relative inset-0 z-10 h-52 w-full object-cover sm:h-full lg:absolute rounded-10")}
          />
        </div>
        <div className="px-8 py-6 lg:basis-1/2 xl:basis-2/3">
          {blok?.title ? <h2 className="pb-4 text-teal-dark">{blok.title}</h2> : null}
          <div className="prose pb-4 lg:prose-lg">{richText(blok.content)}</div>
        </div>
      </div>
    </section>
  )
}
